import * as React from 'react'

import { styled } from '~/styled'
import type { Override } from '~/utilities/types'

const StyledLabel = styled('label', {
  base: ['text-grey-900', 'font-body', 'm-0'],
  variants: {
    size: {
      sm: ['text-sm', 'leading-[1.53]', 'capsize-[0.4056]'],
      md: ['text-md', 'leading-normal', 'capsize-[0.3864]']
    },
    type: {
      block: ['block', 'font-semibold'],
      inline: ['flex', 'font-normal', 'max-w-max']
    },
    align: { start: [], center: [] },
    direction: { reverse: [], row: [] },
    appearance: { standard: [], modern: [] }
  },
  compoundVariants: [
    {
      type: 'inline',
      align: 'start',
      class: ['items-start']
    },
    {
      type: 'inline',
      align: 'center',
      class: ['items-center']
    },
    {
      type: 'inline',
      direction: 'reverse',
      class: ['flex-row-reverse']
    },
    {
      type: 'inline',
      direction: 'row',
      class: ['flex-row']
    },
    {
      type: 'block',
      appearance: 'modern',
      class: ['font-normal']
    }
  ]
})

export type LabelProps = Override<
  React.ComponentPropsWithoutRef<typeof StyledLabel>,
  {
    as?: 'label' | 'legend'
    required?: boolean
  }
>

export const Label = ({
  align = 'start',
  as = 'label',
  direction = 'row',
  size = 'md',
  type = 'block',
  children,
  required,
  ...rest
}: LabelProps) => (
  <StyledLabel
    as={as}
    size={size}
    type={type}
    align={align}
    direction={direction}
    {...rest}
  >
    {children}
    {required && (
      <span className="text-danger ml-1 font-normal" aria-hidden>
        *
      </span>
    )}
  </StyledLabel>
)

Label.displayName = 'Label'
